/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlphabetArabic = createReactComponent("outline", "alphabet-arabic", "IconAlphabetArabic", [["path", { "d": "M10 6v4", "key": "svg-0" }], ["path", { "d": "M13 14h8q -2.518 -3 -4 -3", "key": "svg-1" }], ["path", { "d": "M13 6v9.958c0 .963 0 1.444 -.293 1.743s-.764 .299 -1.707 .299h-1", "key": "svg-2" }], ["path", { "d": "M7 6v9.958c0 .963 0 1.444 -.293 1.743s-.764 .299 -1.707 .299h-1", "key": "svg-3" }]]);

export { IconAlphabetArabic as default };
//# sourceMappingURL=IconAlphabetArabic.mjs.map
